/**
 * Created by anthony on 7/8/14.
 */
var awardLetterTemplatesModel = angular.module("awardLetterTemplatesModel", ["schoolModel"]);
awardLetterTemplatesModel.factory("AwardLetterTemplatesModelFactory", function(SchoolModelFactory) {
    let AwardLetterTemplatesModel = function() {
        this.endpoint = "/AwardLetterTemplate";
        this.primaryKey = "recordID";
    };
    AwardLetterTemplatesModel.prototype = new SchoolModelFactory();
    AwardLetterTemplatesModel.prototype.parent = SchoolModelFactory.prototype;
    AwardLetterTemplatesModel.prototype.resolveData = function() {
        return this.parent.resolveData.apply(this, arguments).then((data) => {
            this.data = data[0].data;
        });
    };
    AwardLetterTemplatesModel.prototype.new = function() {
        const appeal = {title: "", text: "", date: "NOW()", type: 1};
        return (this.data.push(appeal)) - 1;
    };
    AwardLetterTemplatesModel.prototype.getWrapped = function({includeText} = {includeText: true}) {
        return this.get().map((dbResult) => new AwardLetterTemplate(dbResult, includeText));
    };
    return AwardLetterTemplatesModel;
});

awardLetterTemplatesModel.service("AwardLetterTemplatesModelService", function(AwardLetterTemplatesModelFactory) {
    return new AwardLetterTemplatesModelFactory();
});

/**
 * Provides clean typing and internal methods for award letter templates
 */
class AwardLetterTemplate {
    /**
     * @param {Object.<number, string>} dbResult DB result for award letter template
     * @param {boolean} includeText Set to false to prevent storing the .text property
     */
    constructor(dbResult, includeText = true) {
        /** @type {number} */
        this.recordID = Number(dbResult.recordID);
        /** @type {string} */
        this.schoolID = dbResult.schoolID.trim();
        /** @type {string} */
        this.title = dbResult.title.trim();
        /** @type {Date} */
        this.date = new Date(dbResult.date);
        /** @type {number} */
        this.type = Number(dbResult.type);

        // Optionally include the .text property, as it can contain a lot of data
        if (includeText) {
            /** @type {string} (intentionally untrimmed) */
            this.text = dbResult.text;
        }

        /*
         * Attempt to assist date separation as the DB result's highest precision is days.
         * Modulus seconds by 86400 so that the reported day is not incremented.
         */
        this.date.setHours(0);
        this.date.setMinutes(0);
        this.date.setSeconds(this.recordID % 86400);
    }

    /**
     * @returns {number} 0 - ISM, 1 - School
     */
    get user() {
        return this.fromISM ? 0 : 1;
    }

    /**
     * @returns {boolean} True if created by ISM
     */
    get fromISM() {
        return this.schoolID === "0";
    }

    /**
     * @returns {boolean} True if created by the school
     */
    get fromSchool() {
        return this.schoolID !== "0";
    }

    /**
     * @returns {boolean} True if an award template
     */
    get isAward() {
        return this.type === 1;
    }

    /**
     * @returns {boolean} True if a rejection template
     */
    get isReject() {
        return this.type === 0;
    }
}
